import { settings } from '../../../settings/settings-util';

const isLiveChat = (store, passedSettings) => {
    try {
        const selectedSettings = passedSettings || settings;
        const base = selectedSettings?.stateLocations?.LiveChat?.Base;
        const connectionLoc = selectedSettings?.stateLocations?.LiveChat?.sessionState;
        if(!base || !connectionLoc){
            return false;
        }

        const connectionStatus = store?.getState()[base][connectionLoc];
        if (connectionStatus === selectedSettings?.livechat?.sessionState?.online || connectionStatus === selectedSettings?.livechat?.sessionState?.queued) {
            return true;
        }
        else {
            return false;
        }
    }
    catch(e)
    {
        console.log(e);
        return false;
    }
};
export {
    isLiveChat
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-livechat/lib/lib-livechat.js